import produce from 'immer';
import styled from 'styled-components';
import media from '../../../../constants/media';
import { selectStyles } from '../../../base/forms/formikSelect';
import { Columns } from '../../../base/grid';

export const Wrapper = styled.div``;

export const FormWrapper = styled.div``;

export const FieldColumns = styled(Columns)`
	${media.tablet`
        margin-bottom: 3rem;
	`};
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`;

const setFlag = (flag = '#ccc') => ({
	alignItems: 'center',
	display: 'flex',

	':before': {
		backgroundImage: `url(/dist/images/flags-small/${flag.toLowerCase()}.png)`,
		backgroundColor: '#ccc',
		backgroundPosition: '50% 50%',
		backgroundRepeat: 'no-repeat',
		content: '" "',
		display: 'block',
		marginRight: 20,
		height: 30,
		width: 40,
		border: '1px solid #ccc',
	},
});

export const countriesSelectStyles = produce(selectStyles, draftState => {
	// @ts-ignore
	draftState.singleValue = (styles, { data }) => ({
		...styles,
		...setFlag(data.value),
	});
	// @ts-ignore
	draftState.option = (styles, { data }) => ({
		...styles,
		...setFlag(data.value),
	});
});

export const InfoMessageContainer = styled.div`
	font-size: 1.4rem;
	margin: -0.5rem 0 1.5rem 0;
`;

export const InfoWrapper = styled.div`
	font-size: 1.5rem;
	justify-content: space-between;
	padding: 1.5rem 3.5rem;
	background-color: #e8e8e8;
	margin: -2rem 0 3rem 0;
`;

export const StyledErrorMessage = styled.div`
	display: flex;
	align-items: center;
	padding: 1rem 2rem;
	justify-content: center;
	background: #ff7a4c;
	border-radius: 3px;
	color: #000;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
`;
